// extracted by mini-css-extract-plugin
module.exports = {"box":"LogIn_box__AiYzB","codeImg":"LogIn_codeImg__1vj1-","bg":"LogIn_bg__kPoDx","bg2":"LogIn_bg2__NntMp","inputs":"LogIn_inputs__2KMVn","codeInputs":"LogIn_codeInputs__vbYrG"};